import { styled } from '@mui/material'
import ApeironCrossBackground from '@src/components/share/apeiron/ApeironCrossBackground'

const DetailCrossBackground = styled(ApeironCrossBackground)`
  .Custom-Vertical-Background {
    left: 8px;
    right: 8px;
    background: #c6af8f;
    border-radius: 1px;
  }

  .Custom-Vertical-Inner-Background {
    left: 10px;
    right: 10px;
    top: 2px;
    height: calc(100% - 4px);
  }

  .Custom-Horizontal-Background {
    background: #c6af8f;
  }

  .Custom-Horizontal-Inner-Background {
    left: 2px;
    top: 11px;
    bottom: 11px;
    width: calc(100% - 4px);
  }
`

export default DetailCrossBackground
